// REdux
import { configureStore } from '@reduxjs/toolkit';

//reducers
import usersReducer from './reducers/usersSlice.js'; 
import modalReducer from './reducers/modalSlice.js';
import equiposReducer from './reducers/equiposSlice.js';
import estadiosReducer from './reducers/estadiosSlice.js';
import categoriasReducer from './reducers/categoriasSlice.js'
import torneoReducer from './reducers/torneoSlice.js'
import federationsReducer from "./reducers/federacionesSlice.js"
import authReducer from './reducers/authSlice.js';
import partidoReducer from './reducers/partidoSlice.js';
import llaveReducer from './reducers/llaveSlice.js'
import podioReducer from './reducers/podioSlice.js';

const store = configureStore({
  reducer: {
      tournaments: torneoReducer,
      users: usersReducer,
      modal: modalReducer,
      equipos: equiposReducer,
      estadios: estadiosReducer,
      categorias: categoriasReducer,
      federations: federationsReducer,
      auth: authReducer,
      podio: podioReducer,
      partido: partidoReducer,
      llave: llaveReducer,
  },
  devTools: process.env.NODE_ENV !== 'production', // Habilita DevTools solo en desarrollo
});

export default store;